module.exports = __webpack_public_path__ + "static/insurance-hero-301e240b47208d9f9ff57922abf698fa.png";